// extracted by mini-css-extract-plugin
export default {"container":"BurgerIngredients_container__Odot4","link":"BurgerIngredients_link__cjwv+"};